export default __webpack_public_path__ + "static/media/battle-over.08ca46c8.svg";